export default __webpack_public_path__ + "static/media/Ivanoe Cambridge - Log02.8dff89e5.png";